export const SupportedDocumentTypes: SupportedFileTypesInterface<SupportedDocumentLabels>[] = [
  { fileExtension: '.7z', mimeType: 'application/x-7z-compressed', label: '7z' },
  { fileExtension: '.pdf', mimeType: 'application/pdf', label: 'PDF' },
  { fileExtension: '.aac', mimeType: 'audio/x-aac', label: 'AAC' },
  { fileExtension: '.avi', mimeType: 'video/x-msvideo', label: 'AVI' },
  { fileExtension: '.bin', mimeType: 'application/octet-stream', label: 'BIN' },
  { fileExtension: '.csv', mimeType: 'text/csv', label: 'CSV' },
  { fileExtension: '.epub', mimeType: 'application/epub+zip', label: 'EQUB' },
  { fileExtension: '.h261', mimeType: 'video/h261', label: 'H261' },
  { fileExtension: '.h263', mimeType: 'video/h263', label: 'H263' },
  { fileExtension: '.h264', mimeType: 'video/h264', label: 'H264' },
  { fileExtension: '.html', mimeType: 'text/html', label: 'HTML' },
  { fileExtension: '.json', mimeType: 'application/json', label: 'JSON' },
  { fileExtension: '.latex', mimeType: 'application/x-latex', label: 'LATEX' },
  { fileExtension: '.potm', mimeType: 'application/vnd.ms-powerpoint.template.macroenabled.12', label: 'POTM' },
  { fileExtension: '.docm', mimeType: 'application/vnd.ms-word.document.macroenabled.12', label: 'DOCM' },
  { fileExtension: '.dotm', mimeType: 'application/vnd.ms-word.template.macroenabled.12', label: 'DOTM' },
  { fileExtension: '.xls', mimeType: 'application/vnd.ms-excel', label: 'XLS' },
  { fileExtension: '.xlam', mimeType: 'application/vnd.ms-excel.addin.macroenabled.12', label: 'XLAM' },
  { fileExtension: '.xlsb', mimeType: 'application/vnd.ms-excel.sheet.binary.macroenabled.12', label: 'XLSB' },
  { fileExtension: '.xltm', mimeType: 'application/vnd.ms-excel.template.macroenabled.12', label: 'XLTM' },
  { fileExtension: '.xlsm', mimeType: 'application/vnd.ms-excel.sheet.macroenabled.12', label: 'XLSM' },
  {
    fileExtension: '.pptx',
    mimeType: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    label: 'PPTX'
  },
  {
    fileExtension: '.sldx',
    mimeType: 'application/vnd.openxmlformats-officedocument.presentationml.slide',
    label: 'SLDX'
  },
  { fileExtension: '.pages', mimeType: 'application/vnd.apple.pages', label: 'PAGES' },
  {
    fileExtension: '.ppsx',
    mimeType: 'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
    label: 'PPSX'
  },
  {
    fileExtension: '.potx',
    mimeType: 'application/vnd.openxmlformats-officedocument.presentationml.template',
    label: 'POTX'
  },
  {
    fileExtension: '.xlsx',
    mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    label: 'XLSX'
  },
  {
    fileExtension: '.xltx',
    mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
    label: 'XLTX'
  },
  {
    fileExtension: '.docx',
    mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    label: 'DOCX'
  },
  {
    fileExtension: '.dotx',
    mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
    label: 'DOTX'
  },
  { fileExtension: '.ppt', mimeType: 'application/vnd.ms-powerpoint', label: 'PPT' },
  { fileExtension: '.ppam', mimeType: 'application/vnd.ms-powerpoint.addin.macroenabled.12', label: 'PPAM' },
  { fileExtension: '.sldm', mimeType: 'application/vnd.ms-powerpoint.slide.macroenabled.12', label: 'SLDM' },
  { fileExtension: '.pptm', mimeType: 'application/vnd.ms-powerpoint.presentation.macroenabled.12', label: 'PPTM' },
  { fileExtension: '.ppsm', mimeType: 'application/vnd.ms-powerpoint.slideshow.macroenabled.12', label: 'PPSM' },
  { fileExtension: '.mpp', mimeType: 'application/vnd.ms-project', label: 'MPP' },
  { fileExtension: '.pub', mimeType: 'application/x-mspublisher', label: 'PUB' },
  { fileExtension: '.scd', mimeType: 'application/x-msschedule', label: 'SCD' },
  { fileExtension: '.vsd', mimeType: 'application/vnd.visio', label: 'VSD' },
  { fileExtension: '.doc', mimeType: 'application/msword', label: 'DOC' },
  { fileExtension: '.odc', mimeType: 'application/vnd.oasis.opendocument.chart', label: 'ODC' },
  { fileExtension: '.otc', mimeType: 'application/vnd.oasis.opendocument.chart-template', label: 'OTC' },
  { fileExtension: '.odb', mimeType: 'application/vnd.oasis.opendocument.database', label: 'ODB' },
  { fileExtension: '.odf', mimeType: 'application/vnd.oasis.opendocument.formula', label: 'ODF' },
  { fileExtension: '.odft', mimeType: 'application/vnd.oasis.opendocument.formula-template', label: 'ODFT' },
  { fileExtension: '.odg', mimeType: 'application/vnd.oasis.opendocument.graphics', label: 'ODG' },
  { fileExtension: '.otg', mimeType: 'application/vnd.oasis.opendocument.graphics-template', label: 'OTG' },
  { fileExtension: '.odi', mimeType: 'application/vnd.oasis.opendocument.image', label: 'ODI' },
  { fileExtension: '.oti', mimeType: 'application/vnd.oasis.opendocument.image-template', label: 'OTI' },
  { fileExtension: '.odp', mimeType: 'application/vnd.oasis.opendocument.presentation', label: 'ODP' },
  { fileExtension: '.otp', mimeType: 'application/vnd.oasis.opendocument.presentation-template', label: 'OTP' },
  { fileExtension: '.ods', mimeType: 'application/vnd.oasis.opendocument.spreadsheet', label: 'ODS' },
  { fileExtension: '.ots', mimeType: 'application/vnd.oasis.opendocument.spreadsheet-template', label: 'OTS' },
  { fileExtension: '.odt', mimeType: 'application/vnd.oasis.opendocument.text', label: 'ODT' },
  { fileExtension: '.odm', mimeType: 'application/vnd.oasis.opendocument.text-master', label: 'ODM' },
  { fileExtension: '.ott', mimeType: 'application/vnd.oasis.opendocument.text-template', label: 'OTT' },
  { fileExtension: '.rar', mimeType: 'application/x-rar-compressed', label: 'RAR' },
  { fileExtension: '.rtf', mimeType: 'application/rtf', label: 'RTF' },
  { fileExtension: '.rtx', mimeType: 'text/richtext', label: 'RTX' },
  { fileExtension: '.txt', mimeType: 'text/plain', label: 'TXT' },
  { fileExtension: '.wav', mimeType: 'audio/x-wav', label: 'WAV' },
  { fileExtension: '.xml', mimeType: 'application/xml', label: 'XML' },
  { fileExtension: '.fbx', mimeType: 'application/octet-stream', label: 'FBX' },
  { fileExtension: '.obj', mimeType: 'application/octet-stream', label: 'OBJ' },
  { fileExtension: '.mtl', mimeType: 'application/octet-stream', label: 'MTL' },
  { fileExtension: '.ifc', mimeType: 'application/octet-stream', label: 'IFC' },
  { fileExtension: '.svgmesh', mimeType: 'application/octet-stream', label: 'SVGMESH' },
  { fileExtension: '.zip', mimeType: 'application/zip', label: 'ZIP' },
  { fileExtension: '.glb', mimeType: 'model/gltf-binary', label: 'GLB' },
  { fileExtension: '.gltf', mimeType: 'model/gltf+json', label: 'GLTF' }
] as const;

export const SupportedImageTypes: SupportedFileTypesInterface<SupportedImageLabels>[] = [
  { fileExtension: '.bmp', mimeType: 'image/bmp', label: 'BMP' },
  { fileExtension: '.gif', mimeType: 'image/gif', label: 'GIF' },
  { fileExtension: '.jpeg', mimeType: 'image/jpeg', label: 'JPEG' },
  { fileExtension: '.jpg', mimeType: 'image/jpeg', label: 'JPG' },
  { fileExtension: '.jpe', mimeType: 'image/jpeg', label: 'JPE' },
  { fileExtension: '.png', mimeType: 'image/png', label: 'PNG' },
  { fileExtension: '.tiff', mimeType: 'image/tiff', label: 'TIFF' },
  { fileExtension: '.tif', mimeType: 'image/tiff', label: 'TIF' },
  { fileExtension: '.webp', mimeType: 'image/webp', label: 'WEBP' },
  { fileExtension: '.jfif', mimeType: 'image/jpeg', label: 'JFIF' }
] as const;

/**
 * Vector images, accepted only where explicitly requested (e.g. custom category icons) - never part of
 * the photo presets, as the API renders no thumbnails for them.
 */
export const SupportedVectorImageTypes: SupportedFileTypesInterface<SupportedVectorImageLabels>[] = [
  { fileExtension: '.svg', mimeType: 'image/svg+xml', label: 'SVG' }
] as const;

export const SupportedCommonTypes: SupportedFileTypesInterface<SupportedCommonLabels>[] = [
  ...SupportedImageTypes,
  ...SupportedVectorImageTypes,
  ...SupportedDocumentTypes
];

export interface SupportedFileTypesInterface<T> {
  fileExtension: string;
  mimeType: string;
  label: T;
}

export const DefaultSupportedDocumentTypes = SupportedDocumentTypes.filter((doc) => {
  const defaultLabels = [
    'PDF',
    'DOC',
    'XLS',
    'XLSX',
    'DOCX',
    'PPTX',
    'TXT'
  ] as DefaultSupportedDocumentLabelsType[];
  return defaultLabels.includes(doc.label as DefaultSupportedDocumentLabelsType);
});

export type DefaultSupportedDocumentLabelsType = Extract<
  SupportedDocumentLabels,
  'PDF' | 'DOC' | 'XLS' | 'XLSX' | 'DOCX' | 'PPTX' | 'TXT'
>;

export type SupportedCommonLabels = SupportedDocumentLabels | SupportedImageLabels | SupportedVectorImageLabels;

export type SupportedVectorImageLabels = 'SVG';

export type SupportedImageLabels = 'BMP' | 'GIF' | 'JPEG' | 'JPG' | 'JPE' | 'PNG' | 'TIFF' | 'TIF' | 'WEBP' | 'JFIF';

export type SupportedDocumentLabels =
  | '7z'
  | 'PDF'
  | 'AAC'
  | 'AVI'
  | 'BIN'
  | 'CSV'
  | 'EQUB'
  | 'H261'
  | 'H263'
  | 'H264'
  | 'HTML'
  | 'JSON'
  | 'LATEX'
  | 'POTM'
  | 'DOCM'
  | 'DOTM'
  | 'XLS'
  | 'XLAM'
  | 'XLSB'
  | 'XLTM'
  | 'XLSM'
  | 'PPTX'
  | 'SLDX'
  | 'PAGES'
  | 'PPSX'
  | 'POTX'
  | 'XLSX'
  | 'XLTX'
  | 'DOCX'
  | 'DOTX'
  | 'PPT'
  | 'PPAM'
  | 'SLDM'
  | 'PPTM'
  | 'PPSM'
  | 'MPP'
  | 'PUB'
  | 'SCD'
  | 'VSD'
  | 'DOC'
  | 'ODC'
  | 'OTC'
  | 'ODB'
  | 'ODF'
  | 'ODFT'
  | 'ODG'
  | 'OTG'
  | 'ODI'
  | 'OTI'
  | 'ODP'
  | 'OTP'
  | 'ODS'
  | 'OTS'
  | 'ODT'
  | 'ODM'
  | 'OTT'
  | 'RAR'
  | 'RTF'
  | 'RTX'
  | 'TXT'
  | 'WAV'
  | 'XML'
  | 'FBX'
  | 'OBJ'
  | 'MTL'
  | 'IFC'
  | 'SVGMESH'
  | 'ZIP'
  | 'GLB'
  | 'GLTF';
